import { Progress } from "@mantine/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v1/colors";
import { formatSimilarityScore } from "#shared/helpers/formatSimilarityScore";
import { round } from "shared";

import { Tooltip } from "../designSystem/Tooltip";

export default function SimilarityScore({ similarity }: { similarity: number | undefined }) {
  const { t } = useTranslation();
  const hasSimilarity = !!similarity;

  const getScoreColor = useCallback((score: number): string => {
    let color = score ? colors.green[6] : colors.blue[5];

    if (score < 90) {
      color = colors.yellow[6];
    }
    if (score < 70) {
      color = colors.red[6];
    }

    return color;
  }, []);

  const score = formatSimilarityScore(similarity);
  const preciseScore = formatSimilarityScore(similarity, 3);
  const color = getScoreColor(score);

  if (!hasSimilarity) {
    return null;
  }

  const tooltipLabel = t("part.visualSimilarity", { score: preciseScore });

  return (
    <Progress.Root size={"lg"} miw={30}>
      <Tooltip label={tooltipLabel}>
        <Progress.Section value={round(similarity * 100)} color={color}>
          <Progress.Label>{score}%</Progress.Label>
        </Progress.Section>
      </Tooltip>
    </Progress.Root>
  );
}
